import React, { useState } from "react";
import { BranchEmployeesSelect } from "../../../components/forms/AutoCompleteFormItem";
import { Modal } from "antd";
import { useIntl } from "react-intl";
import { Form, Button, Typography, Row, Col } from "antd";
import FormActions from "../../../components/forms/FormActions";
import ChildrenAnimationWrapper from "../../../components/animations/ChildrenAnimationWrapper";
import AnimationChildWrapper from "../../../components/animations/AnimationChildWrapper";
import { CloseOutlined } from "@ant-design/icons";
const { Title } = Typography;
let employeesData = [];

const ReplaceEmployee = (props) => {
  const { hide, onSubmit, visible, branchId } = props;
  const intl = useIntl();
  const [form] = Form.useForm();
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  const onFinish = (values) => {
    onSubmit(selectedEmployee);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onDecline = () => {
    hide();
  };

  const onValuesChange = (values) => {
    const filtered = employeesData.filter(
      (i) => i.id === values.replacer_id
    )[0];
    setSelectedEmployee(filtered);
  };

  const caregiverFilter = {
    $and: [
      { $or: [{ status: 1 }] },

      {
        staff_member: {
          $neq: true,
        },
      },
    ],
  };

  const onDataChanged = (data) => {
    employeesData = data;
  };

  return (
    <Modal
      closable={false}
      maskClosable={false}
      open={visible}
      footer={null}
      onCancel={hide}
      title={null}
      width={"fit-content"}
      styles={{
        body: {
          padding: 0,
        },
      }}
      destroyOnClose={true}
    >
      <div>
        <div className="header" style={{ height: "40px" }}>
          <Button
            style={{ position: "absolute", left: 10, top: 10 }}
            className="closeBtn"
            type="text"
            shape="circle"
            icon={<CloseOutlined />}
            onClick={onDecline}
          />
        </div>
        <Title
          style={{
            fontSize: "30px",
            fontWeight: 500,
            lineHeight: 1.27,
            color: "rgba(0, 0, 0, 0.85)",
            margin: "13px 0 40px 0 ",
            textAlign: "center",
          }}
        >
          {intl.formatMessage({
            id: "app.plan.replace_plan_employee",
          })}
        </Title>
        <Form
          layout={{
            labelCol: { span: 10 },
            wrapperCol: { span: 14 },
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          form={form}
          style={{
            padding: "0 128px 0px 128px",
            width: "650px",
          }}
          onValuesChange={onValuesChange}
        >
          <ChildrenAnimationWrapper>
            <Row>
              <Col span={24} style={{ padding: "0 20px" }}>
                <AnimationChildWrapper itemKey={1}>
                  <BranchEmployeesSelect
                    name="replacer_id"
                    category="plan"
                    getEmployee={branchId !== null}
                    required={true}
                    extraParams={{
                      filter: caregiverFilter,
                      scopePrefix: `branches/${branchId}/`,
                    }}
                    placeholder={intl.formatMessage({
                      id: "app.absences.transfer_sheduling_placeholder",
                    })}
                    onDataChanged={onDataChanged}
                    withId
                  />
                </AnimationChildWrapper>
              </Col>
              <Row style={{ width: "100%" }}>
                <Col span={24}>
                  <FormActions
                    resource={"patients"}
                    action={"editor"}
                    onCancel={onDecline}
                    hideDelete={true}
                    hideDecline={true}
                    mode={"new"}
                    onDecline={onDecline}
                    saveLoading={false}
                    disabled={selectedEmployee == null}
                  />
                </Col>
              </Row>
            </Row>
          </ChildrenAnimationWrapper>
        </Form>
      </div>
    </Modal>
  );
};

export default ReplaceEmployee;
